module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (20).421bbb7a.jpg";